import React from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";

const SettingsLayout: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { currentUser } = useSelector((state: RootState) => state.auth);

  const isCustomer = currentUser?.role?.role_code === "CUSTOMER" || currentUser?.role?.role_code === "ENTERPRISE";

  const tabs = [
    { label: "Profile Details", path: "/dashboard/settings" },
    { label: "Password", path: "/dashboard/settings/profile/change-password" },
    ...(isCustomer ? [{ label: "Payment Settings", path: "/dashboard/settings/payment" }] : []),
  ];

  // Get the active tab index based on the current route
  const activeIndex = tabs.findIndex((tab) => location.pathname === tab.path);

  const handleTabChange = (e: any) => {
    navigate(tabs[e.index].path);
  };

  return (
    <TabView activeIndex={activeIndex} onTabChange={handleTabChange}>
      {tabs.map((tab, index) => (
        <TabPanel key={index} header={tab.label}>
          <Outlet />
        </TabPanel>
      ))}
    </TabView>
  );
};

export default SettingsLayout;
